import React, { useEffect, useRef } from 'react';
import { type FormState } from 'final-form';

import { NavigationLockout } from '@confluence/navigation-lockout';

type SiteSettingsFormLockoutProps<T, S> = {
	formState: FormState<T, S>;
};

// Utility component to lock the site settings forms if the user is navigating away without saving their data
export const SiteSettingsFormLockout = <T, S>({
	formState,
}: SiteSettingsFormLockoutProps<T, S>) => {
	const hasSubmit = useRef(false);

	useEffect(() => {
		if (formState?.submitting) {
			hasSubmit.current = true;
		}
	}, [formState]);

	// If the form has not submitted yet, we use the "dirty" state.
	// If the form has been submitted, "dirty" state persists so we'll use "dirtySinceLastSubmit".
	if ((!hasSubmit.current && formState?.dirty) || formState?.dirtySinceLastSubmit) {
		return <NavigationLockout />;
	}

	return null;
};
